import React from 'react';

import { InOrNotSelector } from 'dashboard/pages/Segment/components/Rule/InSegmentRule/InOrNotSelector';

import { SegmentSelect } from './SegmentSelect';

interface EventOccurredRuleProps {
  base: string;
  readOnly?: boolean;
}

export const InSegmentRule = ({ base, readOnly }: EventOccurredRuleProps) => {
  const notPath = `${base}.ISR.not`;
  const segmentIdPath = `${base}.ISR.segmentId`;

  return (
    <>
      <InOrNotSelector base={base} name={notPath} readOnly={readOnly} />
      <SegmentSelect base={base} name={segmentIdPath} readOnly={readOnly} />
    </>
  );
};
